import { render, staticRenderFns } from "./SendPaymentDetails.vue?vue&type=template&id=1e1bdd95&scoped=true"
import script from "./SendPaymentDetails.vue?vue&type=script&lang=js"
export * from "./SendPaymentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1bdd95",
  null
  
)

export default component.exports